import Vue from 'vue'
import { Component } from 'vue-property-decorator'

import AppDialog from '@/components/AppDialog.vue'
import { AccountAsset } from '@/modules/AccountAsset/interfaces/account-asset'
import { SnackType } from '@/interfaces/snack'
import { showErrors, showNotification } from '@/utils/snack'

import AssetVehicleForm from '@/modules/AccountAsset/components/AssetVehicleForm.vue'
import { deleteAccountAsset } from '@/modules/AccountAsset/gql/account-asset.gql'

@Component({
  components: {
    AppDialog,
    AssetVehicleForm
  }
})
export default class AssetVehicleDialog extends Vue {
  targetAccountAsset: AccountAsset | null = null

  vehicleDialog = {
    actionType: 'new',
    show: false,
    title: 'New Asset',
    disable: false
  }

  deleteVehicleDialog = {
    show: false,
    title: 'Delete Asset',
    text: ''
  }

  showVehicleEditDialog (e: Event, targetAccountAsset?: AccountAsset) {
    e.preventDefault()
    e.stopPropagation()
    let actionType = 'new'
    let title = 'New Asset'
    if (targetAccountAsset) {
      this.targetAccountAsset = targetAccountAsset
      actionType = 'edit'
      title = 'Edit Asset'
    }
    this.vehicleDialog = {
      actionType,
      show: true,
      title,
      disable: false
    }
  }

  hideVehicleEditDialog () {
    this.targetAccountAsset = null
    this.vehicleDialog = {
      actionType: 'new',
      show: false,
      title: 'New Vehicle',
      disable: false
    }
  }

  async deleteAccountAsset (e: Event, accountAsset: AccountAsset) {
    e.preventDefault()
    e.stopPropagation()
    this.targetAccountAsset = accountAsset
    this.deleteVehicleDialog.show = true
  }

  async deleteVehiclePost () {
    if (!this.targetAccountAsset) {
      return
    }
    const { id } = this.targetAccountAsset
    this.deleteVehicleDialog.show = false
    try {
      const result = await this.$apollo.mutate({
        mutation: deleteAccountAsset,
        variables: {
          accountAssetId: Number(id)
        }
      })

      const res = result.data.deleteAccountAsset
      if (res) {
        showNotification({
          msg: 'Delete vehicle successfully',
          type: SnackType.Success
        })
        this.targetAccountAsset = null
      }
    } catch (error) {
      showErrors(error.graphQLErrors)
    }
  }
}
